import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController, AlertController, ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { intervalToDuration } from 'date-fns';
import { forkJoin, pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppComponent } from 'src/app/app.component';
import { PlatformService } from 'src/app/platform.service';
import { AppealsService } from 'src/app/services/appeals.service';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { VehiclesService } from 'src/app/services/vehicles.service';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Swiper, EffectCoverflow } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { PermitInfoPage } from '../../modals/permit-info/permit-info.page'
import { HeaderComponent } from 'src/app/components/header/header.component';
SwiperCore.use([Navigation, EffectCoverflow, Pagination]);
import { LocalNotificationActionPerformed, LocalNotifications } from '@capacitor/local-notifications'
import { ExtendparkingPage } from 'src/app/modals/extendparking/extendparking.page';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnDestroy  {
  @ViewChild(HeaderComponent, { static: false }) test: HeaderComponent;
  subscriptionEvent;
  loaded = false;
  unpaidViolations: any = [];
  activeDeposits: any = [];
  activeLockers: any = [];
  tempPermits: any = []
  standardPermits: any = []
  vehiclesConfig: SwiperOptions = {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true
    },
     
    slidesPerView: 1.1,
    centeredSlides:true,
    pagination: { clickable: true }
  };
  violationsConfig: SwiperOptions = {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true
    },
     
    slidesPerView: 1.1,
    centeredSlides:true,
    pagination: { clickable: true }
  };
  permitsConfig: SwiperOptions = {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true
    },
     
    slidesPerView: 1.1,
    centeredSlides:true,
    pagination: { clickable: true }
  };
  lockersConfig: SwiperOptions = {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true
    },
     
    slidesPerView: 1.1,
    centeredSlides:true,
    pagination: { clickable: true }
  };
  constructor(
    private toastController: ToastController,
    public platformSRV: PlatformService,
    private translate: TranslateService,
    private actionSheetCtrl: ActionSheetController,
    private errorHandlerSRV:ErrorHandlerService,
    private router:Router,
    public alertController: AlertController,
    public modalController: ModalController,
    public loaderSRV:LoaderService,
    public appComp:AppComponent,
    public appealsSRV:AppealsService,
    public vehiclesSRV:VehiclesService,
    public dataService: DataService) {
    
  }

  async PermitInfo(permit, type) {
    const desktopModal = await this.modalController.create({
      component: PermitInfoPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        permit: permit,
        type: type
      }
    });
    const mobileModal = await this.modalController.create({
      component: PermitInfoPage,
      breakpoints: [0.5, 0.85, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        permit: permit,
        type: type
      }
    });
    const tabletModal = await this.modalController.create({
      component: PermitInfoPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        permit: permit,
        type: type
      }
    });
     var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
     modal.onDidDismiss().then(data=>{
      if(data.data=="refresh"){
        this.loadData()
      }
    })
     modal.present()
    
    
    
    
  }
  handleRefresh(event) {
    this.loadData()
    event.target.complete();

  }
  

  
  
   ionViewDidEnter() {
     LocalNotifications.requestPermissions()
   
    this.subscriptionEvent= this.dataService.isAuthenticated.subscribe(isLoggedIn=>{
      if(isLoggedIn){
       this.loadData()
      } else {
        this.loaded = false
        this.unpaidViolations = [];
        this.activeDeposits = [];
        this.activeLockers = [];
        this.tempPermits = []
        this.standardPermits = []
        this.vehiclesSRV.vehicles = {}
        this.ngOnDestroy()
      }

    })


  }
  ngOnDestroy() {
    if (this.subscriptionEvent) {
      this.subscriptionEvent.unsubscribe()
    }

  }
  async vehicleOptions(vehicle) {
    if (this.vehiclesSRV.loadingToggleChange.value == false) {
      var stateMessage;
      if (vehicle.Active) {
        stateMessage = this.translate.instant('keys.data.vehicles.switch_to_inactive')
      } else {
        stateMessage = this.translate.instant('keys.data.vehicles.switch_to_active')
      }
      const alert = await this.alertController.create({
        header: this.translate.instant('keys.data.vehicles.vehicle') + ' ' + vehicle.Plate,

        buttons: [
          {
            text: this.translate.instant('keys.data.common.edit'),
            handler: (async () => {
              this.vehiclesSRV.openEditVehicleModal(vehicle)
            })
          },
          {
            text: stateMessage,
            handler: (async () => {
              this.vehiclesSRV.onToggleActiveFromHomepage(vehicle)
            })
          },
          {
            text: this.translate.instant('keys.data.common.cancel'),
            role: 'cancel',

          },
        ]
      })
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('keys.data.vehicles.vehicle') + ' ' + vehicle.Plate,
        mode: "ios",
        buttons: [
          {
            text: this.translate.instant('keys.data.common.edit'),
            handler: (async () => {
              this.vehiclesSRV.openEditVehicleModal(vehicle)
            })
          },
          {
            text: stateMessage,
            handler: (async () => {
              this.vehiclesSRV.onToggleActiveFromHomepage(vehicle)
            })
          },
          {
            text: this.translate.instant('keys.data.common.cancel'),
            role: 'cancel',
            data: {
              action: 'cancel',
            },
          },
        ],
      });
      if (this.platformSRV.device == 'desktop') {
        alert.present()
      }
      else {
        actionSheet.present();
      }

    }

  }

  loadData(){
    this.dataService.getUserInfo()
    this.dataService.getData('api/v1/user/home').subscribe({
      next:res=>{
        var start = new Date()
        var violations=[];
        if(res['status']=="success"){
         
            res['violations'].forEach(element => {
              if(start<new Date(element['Due'])){
                element['timeLeft']= intervalToDuration({
                  start: start,
                   end: new Date(element['Due'])
                })
              }
              
            });
            res['violations'].forEach(element => {
              if(!element['payID']){
                violations.push(element)
              }
            })
          
         
          
          
          if(violations.length>0){
                this.unpaidViolations = violations;
              } else {
                this.unpaidViolations =[]
              }
        
        
        
          this.vehiclesSRV.vehicles=res['vehicles']
        
        if(res['standard_permits']){
          this.standardPermits=res['standard_permits']
        }
        if(res['temp_permits']){
          res['temp_permits'].forEach(element => {
            var startDate= new Date(element['StartDate'])
            var EndDate= new Date(element['EndDate'])
            if(startDate.toDateString() == EndDate.toDateString()){
              element['sameDay']=true
            } else {
              element['sameDay']=false
            }
          })
          var minutes;
          if(this.dataService.user['remindertime'] && this.dataService.user['remindertime']!=0){
            minutes = this.dataService.user['remindertime']
          } else {
            minutes = 15
          }
          
         
          
          this.tempPermits=res['temp_permits']
           LocalNotifications.getPending().then(async res=>{
          
            
            if(res.notifications.length>0){
              await LocalNotifications.cancel(res)
            }
            for(var i = 0;i<this.tempPermits.length;i++){
              if(this.tempPermits[i]['endTime']){
              var notificationTime = new Date(this.tempPermits[i]['EndDate'])
              notificationTime.setMinutes(notificationTime.getMinutes() - parseInt(minutes) )
              
              await LocalNotifications.schedule({
                notifications:[
                  {
                    title:"Permit About to expire",
                    body:"your permit will expire in "+minutes+" minutes, click here to extend permit",
                    id:i,
                    schedule:{
                      at: notificationTime,
                      allowWhileIdle:true
                    },
                    extra:{
                      data:this.tempPermits[i]
                    }
                    
                  },
                  //for sending a notification after 3 seconds (testing)
                  // {
                  //   title:"Permit About to expire",
                  //   body:"your permit will expire in 15 minutes, click here to extend permit",
                  //   id:i,
                  //   schedule:{
                  //     at: new Date(Date.now() + 1000 * 3),
                  //     allowWhileIdle:true
                  //   },
                  //   extra:{
                  //     data:tempPermits[i]
                  //   }
                  // }
                  
                 ]
              })}
             
              
            }
           await LocalNotifications.addListener('localNotificationActionPerformed',async (notification:LocalNotificationActionPerformed)=>{
             
              const desktopModal = await this.modalController.create({
                component: ExtendparkingPage,
                breakpoints: [0.5, 0.8,1],
                initialBreakpoint: 1,
                cssClass: 'modal-desktop-long',
                componentProps: {
                  permit:notification['notification']['extra']['data']
                }
              });
              const mobileModal = await this.modalController.create({
                component: ExtendparkingPage,
                breakpoints: [0.5, 0.85,1],
                initialBreakpoint: 1,
                cssClass: 'modal-mobile-normal',
                componentProps: {
                  permit:notification['notification']['extra']['data']
                }
              });
              const tabletModal = await this.modalController.create({
                component: ExtendparkingPage,
                breakpoints: [0.5, 0.85,1],
                initialBreakpoint: 1,
                cssClass: 'modal-tablet-normal',
                componentProps: {
                  permit:notification['notification']['extra']['data']
                }
              });
              if(this.platformSRV.device=='desktop'){
                return await desktopModal.present();
              } else if(this.platformSRV.device=='mobile'){
                return await mobileModal.present();
              } else if(this.platformSRV.device=='tablet'){
                return await tabletModal.present();
              }
              
              
            })
           
          })
      } 
      var deposits=[]
      for (
        var i = 0;
        i < Object.entries(res['active_deposits']).length;
        i++
      ){
       deposits.push(res['active_deposits'][i])
        
      }
      this.activeDeposits=deposits
  
   
      this.activeDeposits=deposits
      var lockers=[]
      for (
        var i = 0;
        i < Object.entries(res['active_lockers']).length;
        i++
      ){
       lockers.push(res['active_lockers'][i])
        
      }
      this.activeLockers = lockers
  
     this.loaded=true

     }
      
     
     },
     error:err=>{
      this.loaded=true
      this.errorHandlerSRV.displayErrorMessage(err,true)
    }})
     
      
  }


}
